import $ from 'jquery';
window.$ = $ ;

import jQuery from 'jquery';

import {Globals, handleAjaxError, checkError } from "root/DataFunctions/BaseDataFns";

export { Globals, handleAjaxError, handleAxiosError, getCookie, checkError, setCookie, displayAlert } ;

import ErrorStackParser from 'error-stack-parser';

import Modal from './Modals/VanillaModal/VanillaModal' ;
import "./Modals/VanillaModal/Modal.scss" ;

// *********************************************
// DISPLAY ERRORS - IN PROGRESS
//*********************************************

function setCookie(cname,cvalue,exdays)
{
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname)
{
    var name = cname + "=";

    var decodedCookie = decodeURIComponent(document.cookie);

    var ca = decodedCookie.split(';');

    for(var i = 0; i < ca.length; i++)
    {
        var c = ca[i];
        while (c.charAt(0) == ' ')
        {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0)
        {
            return c.substring(name.length, c.length);
        }
    }

    return "";
}

function displayAlert ( params )
{
    let title = 'Alert' ;
    let displayMessage = "EMPTY MESSAGE" ;

    if ( params.title != null )
    {
        title = params.title ;
    }

    if ( params.message != null )
    {
        displayMessage = params.message ;
    }

    bootbox.alert({
        size: "large",
        title: title,
        message: displayMessage,
        callback: function()
        {
        }
    })
}

const handleAxiosError = (error, returnUrl) =>
{
    console.log(error);

    const stackFrames = getThisErrorObject() ;

    const callingFrame = stackFrames[2] ;

    let fullMessage = error.message +
        '<p>In ' + callingFrame.functionName + ' in ' + callingFrame.fileName + ' Line number ' + callingFrame.lineNumber +  '</p>' +
        'Attempting to call ' + error.request.responseURL + '</p>';

    if ( error.response != null )
    {
        if ( error.response.data != null )
        {
            if ( error.response.data.errorType == 'exception')
            {
                fullMessage += "<p>API Error in " + error.response.data.errorDetail.file + " at line " + error.response.data.errorDetail.line + '<p>' ;
                fullMessage += '<p>' + error.response.data.errorDetail.message + '<p>' ;
            }
        }
    }

    bootbox.alert({
        size: "large",
        title: "The operation failed " + error.message,
        message: fullMessage,
        callback: function()
        {
            if ( returnUrl != null )
            {
                location.assign(returnUrl);
            }
        }
    })
}

const  getThisErrorObject = () =>
{
    try
    {
        throw Error('')
    }
    catch(err)
    {
        const res = ErrorStackParser.parse(err);

        return res;
    }
}

/*globals jQuery, window */
(function($) {
    $.retryAjax = function (ajaxParams) {
        var errorCallback;
        ajaxParams.tryCount = (!ajaxParams.tryCount) ? 0 : ajaxParams.tryCount;
        ajaxParams.retryLimit = (!ajaxParams.retryLimit) ? 2 : ajaxParams.retryLimit;
        ajaxParams.suppressErrors = true;

        if (ajaxParams.error) {
            errorCallback = ajaxParams.error;
            delete ajaxParams.error;
        } else {
            errorCallback = function () {

            };
        }

        ajaxParams.complete = function (jqXHR, textStatus) {
            if ($.inArray(textStatus, ['timeout', 'abort', 'error']) > -1) {
                this.tryCount++;
                if (this.tryCount <= this.retryLimit) {

                    // fire error handling on the last try
                    if (this.tryCount === this.retryLimit) {
                        this.error = errorCallback;
                        delete this.suppressErrors;
                    }

                    //try again
                    $.ajax(this);
                    return true;
                }

                window.alert('There was a server error.  Please refresh the page.  If the issue persists, give us a call. Thanks!');
                return true;
            }
        };

        $.ajax(ajaxParams);
    };
}(jQuery));

(function($) {

    $.originalAjax = $.ajax ;

    $.ajax = function (ajaxParams) {

        ajaxParams.loggingIn = false;

        let oldError = ajaxParams.error;

        ajaxParams.error = function (jqXHR, textStatus, error)
        {
            if ( errorOccurredBecauseAuthenticationRequired( this, jqXHR, textStatus, error ) )
            {
                // if we're handling an authentication error, it probably means the user has a session timeout
                // so we need to ask them to re-authenticate
                //
                // Once the user has logged in again, we can continue the request using the original parameters

                ajaxParams.loggingIn = true ;

                tryAgain ( this, textStatus, jqXHR );
            }
            else
            {
                // Just pass the result on to the original Success handler
                if ( oldError != null )
                {
                    oldError(jqXHR, textStatus, error);
                }
            }
        };

        $.originalAjax(ajaxParams);
    };
}(jQuery));

function errorOccurredBecauseAuthenticationRequired ( response, jqXHR, textStatus, error )
{
    let res = false ;

    if ( response.loggingIn == true )
    {
        // This is a successful route
        res = false ;
    }
    else
    {
        let data = jqXHR.responseJSON ;

        if ( data != null && data.result != null && data.result == "fail" && data.error != null && ( data.error == "Authentication Fail" || data.error == 'authenticationException') )
        {
            res = true ;
        }
    }

    return res ;
}

function functionFailedBecauseAuthenticationRequired ( response, data )
{
    let res = false ;

    if ( response.loggingIn == true )
    {
        // This is a successful route
        res = false ;
    }
    else
    {
        if ( data != null && data.result != null && data.result == "fail" && data.error != null && data.error == "Authentication Fail" )
        {
            res = true ;
        }
    }

    return res ;
}

function doLogin( response, textStatus, jqXHR, username, password, establishment )
{
    // Globals are defined in the globals.js class
    var root = Globals.APIFolder ;

    var service = "/login" ;

    $.ajax({
        type: 'POST',
        url: root + service,
        data: { inpUsername: username, inpPassword: password, inpEstablishmentNumber: establishment  },
        success:(data)=>
        {
            if ( data.status.result == 'success')
            {
                $.originalAjax ( response ) ;
            }
            else
            {
                tryAgain ( response, textStatus, jqXHR) ;
            }
        },
        error:(jqXHR, textStatus, error)=>
        {
            handleAjaxError ( jqXHR, textStatus, error) ;
        }
    });
}

function loginFormElements ()
{
    var string = "<div>" ;

    string+= '<h2>Session Timed Out</h2>' ;

    string+= '<p>Your session has timed out.</p>' ;

    string+= '<p>Please re-enter your login credentials to continue</p>' ;

    string += "<form class='form' role='form'>" ;
    string += '<div class="form-group">' ;
    string += '<label for="inputEstablishment">Establishment Number</label>' ;
    string += '<input type="text" class="form-control" id="inputEstablishment" name="inputEstablishment" placeholder="Establishment NUmber">' ;
    string += '</div> ' ;
    string += '<div class="form-group">' ;
    string += '<label for="inputUserName">User Name</label>' ;
    string += '<input type="text" class="form-control" id="inputUserName" name="inputUserName" placeholder="User Name">' ;
    string += '</div> ' ;
    string += '<div class="form-group"> ';
    string += '<label for="inputPassword">Password</label>' ;
    string += '<input type="password" class="form-control" id="inputPassword" name="inputPassword" placeholder="Password"> ' ;
    string += '</div>';
    string += "</form>" ;
    string += "<div>" ;

    return string ;
}

function tryAgain ( response, textStatus, jqXHR)
{
    var form = loginFormElements () ;

    var modal = bootbox.dialog({
        message: form,
        title: "",
        buttons: [
            {
                label: "Login",
                className: "btn btn-primary pull-right",
                callback: function() {

                    var inputUserName = $('div.bootbox-body form.form div.form-group input#inputUserName');
                    var userName = inputUserName[0].value;

                    var inputUserPassword = $('div.bootbox-body form.form div.form-group input#inputPassword');
                    var userPassword = inputUserPassword[0].value;

                    var inputEstablishment = $('div.bootbox-body form.form div.form-group input#inputEstablishment');
                    var establishment = inputEstablishment[0].value;

                    doLogin ( response, textStatus, jqXHR, userName, userPassword, establishment) ;

                    return true;
                }
            }
        ],
        show: false,
        onEscape: function() {
            modal.modal("hide");
        }
    });

    modal.modal("show");
}


function showSpinner()
{
    $('#spin-container').show();
    $('#spin-wrapper').show();
}

function hideSpinner()
{
    $('#spin-container').hide();
    $('#spin-wrapper').hide();
}
